import { Fragment, memo } from "react";
import { useParams, Link } from "react-router-dom"

import Spinner from 'react-bootstrap/esm/Spinner';
import { useFetchData } from '../../../Hooks/Main/useFetchData';
import HtmlDecode from '../../../Utils/HtmlDecode';

import './style.css'
import LazyImage from "../../../Components/LazyImage";

const imageUrl = process.env.REACT_APP_FILE_URL


function OurProgram() {
  const {id} = useParams()
    const lang = localStorage.getItem("i18nextLng");
  const { data, isLoading } = useFetchData(`viewOurProgram/${id}`, lang);
  const { data: programs, isLoading: programLoading } = useFetchData("ourPrograms", lang);
  const filteredPrograms = programs?.ourPrograms?.filter(program=> program.isTitle !==true)
    return (
      <div className="container-fluid p-0">
        {!isLoading ? (
          <Fragment>
            <div className="position-relative d-flex justify-content-center pagesHeaderCoverImages">
              <LazyImage src={`${imageUrl}${data?.images?.file}`} className="img img-fluid"/>
              <div className="image-frame__wrapper">
                <h2>{data?.title} for {data?.related?.name}</h2>
              </div>
            </div>
            <div className="container">
              <div className="row mt-5 mx-1">
                <div className="col-md-12">
                    <p>
                      <span dangerouslySetInnerHTML={{__html: HtmlDecode(data?.content)}}
                      />
                    </p>
                  </div>
                </div>
            </div>
          </Fragment>
          ): (
          <div className="d-flex justify-content-center mt-3">
            <Spinner animation="grow" className="me-2" />
            Loading Content...
          </div>
          )
        }
        
        <div className="container mb-5 mt-5">
          <h4 className='text-title mt-4 ms-2'>Other Projects</h4>
          <div className="row mt-5">
          {filteredPrograms &&  filteredPrograms?.filter(program => program._id !== id).map((program, index) => {
              return (
                <div className="col-md-4 mb-3" key={index}>
                  <div className="zoom-content-on-hover border rounded position-relative shadow program-main">
                    <div className="my-image-wrapper h-50 vh-50">
                      {program?.images && <LazyImage src={`${imageUrl}${program.images?.file}`} className="img img-fluid" style={{
                          aspectRatio: "2/1",
                          objectFit: "cover",
                          maxHeight: "100%",
                          height:"230px",
                          width: "100%",
                        }}/>}
                    </div>
                    <div className="program-title d-flex justify-content-center">
                      <h6 className="text-title fw-light"><span
                          dangerouslySetInnerHTML={{
                            __html: `${HtmlDecode(program?.title)}`,
                          }}/></h6>
                    </div>
                      <div className="programs-content px-3">
                        <p>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${HtmlDecode(program?.content?.substring(0,200))}...`,
                          }}
                        />
                      <Link
                        to={`/our-program-details/${program?._id}`}
                        className="text-decoration-none program-link link-title fs-6 fw-inline fw-light"
                      >
                        Read More
                      </Link>
                    </p>
                      </div>
                  </div>
                </div>
              )
            }
            )}

        </div>
        </div>
        {/* <div class="first">
          <div class="box">Lorem ipsum dolor sit amet</div>
          <div class="box">consectetur adipiscing elit</div>
          <div class="box">sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod tempor incididunt ut labore et dolore magna aliqua sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</div>
        </div> */}
      </div>
    )
}

export default memo(OurProgram)